module.exports = __webpack_public_path__ + "static/service-img-9f64f8142b5fad2dda398dc9e0173d71.png";